import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Services } from '../components/Services';
import { Process } from '../components/Process';
import { Leadership } from '../components/Leadership';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen w-full bg-white font-sans" data-id="element-254">
      <Header data-id="element-255" />
      <main data-id="element-256">
        <Hero data-id="element-257" />
        <About data-id="element-258" />
        <Services data-id="element-259" />
        <Process data-id="element-260" />
        <Leadership data-id="element-261" />
        <Contact data-id="element-262" />
      </main>
      <Footer data-id="element-263" />
    </div>;
}